import * as swcHelpers from '@swc/helpers';
import { useEffect } from 'react';
import { useTealium } from '../provider.js';
import { createCustomEvent } from './utils.js';

function useTrackPageView(pageDetails) {
    const { hasInstance  } = useTealium();
    useEffect(()=>{
        const dispatchEvent = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                if (!hasInstance) return;
                try {
                    const details = yield pageDetails();
                    const event = createCustomEvent(details);
                    globalThis.dispatchEvent(event);
                    console.log('Page view event dispatched:', details);
                } catch (error) {
                    console.error('Error dispatching page view event:', error);
                }
            });
            return function dispatchEvent() {
                return _ref.apply(this, arguments);
            };
        }();
        dispatchEvent();
    }, [
        pageDetails,
        hasInstance
    ]);
}

export { useTrackPageView };
//# sourceMappingURL=use-track-page-view.js.map
